export const scrollToTop = () => {
  // console.log('scrollToTop');
  // document.body.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest"});
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
  // var position = document.body.scrollTop || document.documentElement.scrollTop;
  // if (position) {
  //   console.log('position', position);
  //   setTimeout(() => {
  //     window.scrollTo(0, -Math.max(1, Math.floor(position / 10)));
  //   }, 30);
  // }
}

export const setToTop = () => {
  // console.log('setToTop');
  window.scrollTo({
    'behavior': 'auto',
    'left': 0,
    'top': 0
  });
}

export const scrollToElement = (el, isBottom, noScroll) => {
  // console.log('scrollToElement el', el);
  const curPos = document.documentElement.scrollTop || document.body.scrollTop;
  const timer = document.getElementById('timer');
  const timerHeight = timer ? timer.offsetHeight : 0;
  const adminBar = document.getElementById('wpadminbar');
  const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
  // console.log('adminBarHeight', adminBarHeight);
  // console.log('current scroll pos', curPos);
  // document.getElementById(el).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  const element = document.getElementById(el);
  const elementRectTop = element.getBoundingClientRect().top;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  // console.log('elementRectTop', elementRectTop);
  const elementPosition = elementRectTop + scrollTop;
  // console.log('elementPosition', elementPosition);
  const offset = window.innerWidth >= 768 ? 123 : 80;
  // console.log('offset', offset);
  const elHeight = isBottom ? element.offsetHeight : 0;
  // console.log('elHeight', elHeight);
  const relativePos = curPos - (elementPosition + offset);
  // console.log('element relativePos', relativePos);

  const doScroll = (Math.abs(relativePos) <= 10 || noScroll) ? false : true;
  // console.log('doScroll', doScroll);
  const behavior = doScroll ? 'auto' : 'smooth';
  // console.log('scroll behavior', behavior);
  const offsetPosition = elementPosition - offset + elHeight - timerHeight - adminBarHeight;
  // console.log('offsetPosition', offsetPosition);
  window.scrollTo({
    'behavior': 'smooth',
    'left': 0,
    'top': offsetPosition
  });
}
